import React from 'react';
import {
  Accordion,
  AccordionSummary,
  Tooltip,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { styleCollective } from './styleService';
import DownloadIcon from "@material-ui/icons/GetApp";
import moment from 'moment';
import { headers } from './headers';
import { downloadCollectiveService } from '../../actions/collective-service-action';

const AccordionCollectiveService = ({
  data,
  message,
  setMessage,
  handleClickClose
}) => {
  const classes = styleCollective();

  const getValueKey = (object, header) => {
    if (header.child === null) {
      if(header.field === 'creation'){
        const creation = data?.creationDate ? moment(data?.creationDate).format('DD-MM-YYYY') : null;
        return creation;
      }
      if(header.field === 'laboratory'){
        const laboratory = data?.medicalLab?.laboratoryName;
        return laboratory;
      }
      if(header.field === 'company'){
        const regional = data?.company;
        return regional;
      }
      if (header?.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        return object[header?.field];
      }
      return "";
    }
    return object[header?.field] !== null
    ? object[header?.field][header?.child]
    : "";
  };

  const downloadFile = async (info) => {
    const response = await downloadCollectiveService(info?.id);
    if(response?.status === 200 || response?.status === 201){
      if(response?.data?.data){
        downloadExam(response.data)
      }else{
        isEmptyDataPdf()
      }
    }else{
      setMessage({
        description : response?.data?.detail ? response?.data?.detail : response?.data?.error,
        textButtonSubmit : 'ACEPTAR',
        handleClick : () => handleClickClose() ,
        oneButtons : true,
        type : 'WARNING',
        open : true
      })
    }
  }

  function downloadExam(pdf) {
    const url = `data:@file/pdf;base64,${pdf?.data}`;
    const downloadLink = document.createElement("a");
    const fileName = `${pdf?.name ?? 'file'}`;

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const isEmptyDataPdf = () => {
    setMessage({
      description : 'No se encontro información para descargar',
      textButtonSubmit : 'ACEPTAR',
      handleClick : () => handleClickClose() ,
      oneButtons : true,
      type : 'WARNING',
      open : true
    })
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
        flexDirection: "row-reverse",
    },
  })(AccordionSummary);
    FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div style={{width: '100%', marginTop: '10px'}} >
      <Accordion style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}>
        <FlippedOrderExpansionPanelSummary
          aria-controls='panel1c-content'
          id={'id'}
          style={{paddingLeft: '20px', pointerEvents: 'none'}}
        >
            {
                headers.initialHeaders?.map((header) => (
                <div className={classes.column} key={data?.id}>
                    <Typography className={classes.heading}>
                        {header?.title}
                    </Typography>
                    <Typography className={classes.secondaryHeading} style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                        {getValueKey(data, header)}
                    </Typography>
                </div>
                ))
            }
            <div className={classes.contIconDownload}>
                <Tooltip title="Descargar" arrow placement="top">
                    <DownloadIcon 
                        onClick={(e) => {e.stopPropagation(); downloadFile(data)}}
                        className={classes.iconEvent} 
                        style={{cursor: "pointer", pointerEvents: "auto"}}
                    />
                </Tooltip>
            </div>
        </FlippedOrderExpansionPanelSummary>
      </Accordion>
    </div>
  )
}

export default AccordionCollectiveService